// ─── /learn route map (KAN-273 reworked learner flow) ─────────────────────────
//
// One place for every learner-facing path in the new flow, so a rename (the
// Flare's external name is still TBD — flow proposal D9) is a one-line change
// here and nowhere else. Pages, the dashboard, redirects and tests all import
// from this file; nothing under /learn should hard-code a path.
//
// Flow shape (proposal §1):
//   1. /learn                      dashboard — the spine; to-dos gate on state
//   2. /learn/assessment/<flare>   first experience (short Flare set)
//   3. /learn/analysis             readout of that session (debrief only)
//      /learn/map                  constellation (dark until FC — conflict A, rec (b))
//   4. /learn/profile              "Tell us more"  (light profile build)
//   5. /learn/interview            "Talk to us"    (AI interview)
//   6. /learn/assessment/futurecapability   the FC assessment (moved from /test)
//   7. /learn/build                "Build future capability" — the Boundary (CCS bouts)

// External name TBD (D9). Placeholder slug; change here only.
export const FLARE_SLUG = 'first-look';
export const FC_SLUG = 'futurecapability';

export const LEARN_ROUTES = {
  dashboard: '/learn',
  flare: `/learn/assessment/${FLARE_SLUG}`,
  analysis: '/learn/analysis',
  map: '/learn/map',
  profile: '/learn/profile',
  interview: '/learn/interview',
  fc: `/learn/assessment/${FC_SLUG}`,
  // Legacy MCQ-test shapes (session/result by id). The fc-attempt assessment is one
  // page at `fc`; these now redirect (session → fc, result → map). Kept so old
  // links and tests resolve; do not build new paths on them.
  fcSession: (sessionId) => `/learn/assessment/${FC_SLUG}/session/${sessionId}`,
  fcResult: (sessionId) => `/learn/assessment/${FC_SLUG}/result/${sessionId}`,
  build: '/learn/build',
  // The bout runner behind the Boundary landing page. /learn/build is the course
  // shell (one open step); the runner is where a started bout actually plays.
  boutRunner: '/learn/build/bout',
  // KAN-281 evidence-tier profile (was /learn/profile before the flow rework).
  // Not a to-do; retained as a route so nothing that links to it dead-ends.
  evidence: '/learn/evidence',
  // V1.4 MC03: what the system understands about how the learner plans and decides.
  aboutYou: '/learn/about-you',
};

// Route-pattern forms for <Route path=...> (react-router params).
export const LEARN_ROUTE_PATTERNS = {
  fcSession: `/learn/assessment/${FC_SLUG}/session/:sessionId`,
  fcResult: `/learn/assessment/${FC_SLUG}/result/:sessionId`,
};

// Old paths → new. Kept as redirects so bookmarks, emails and the older
// pages' own navigate() calls keep working while everything migrates.
export const LEGACY_REDIRECTS = [
  { from: '/test', to: LEARN_ROUTES.fc },
  { from: '/learn/first-run', to: LEARN_ROUTES.flare },
  { from: '/learn/start', to: LEARN_ROUTES.profile },
];
